export const WriterIcon = ({ width = 24, height = 24, style = {} }) => (
  <svg
    t="1758861457896"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
  >
    <path
      d="M843.906 608.942l-143.874-17.984A32 32 0 0 1 672 559.2V480h-160v79.232a31.944 31.944 0 0 1-27.984 31.714c-34.37 4.29-94.242 11.766-144.012 17.984a95.89 95.89 0 0 0-84 95.16V928a48 48 0 0 0 48 48H880a48 48 0 0 0 48-48V704.2a96 96 0 0 0-84.094-95.258z"
      fill="#FEC9A3"
      p-id="3002"
    ></path>
    <path
      d="M843.908 608.942l-140.856-17.6a122.986 122.986 0 0 1-217-0.834c-0.674 0.13-1.308 0.356-2 0.442-34.358 4.288-94.226 11.764-144 17.984a95.904 95.904 0 0 0-84.052 95.2v223.876a48 48 0 0 0 48 48h576a48 48 0 0 0 48-48V704.2a96 96 0 0 0-84.092-95.258z"
      fill="#F35244"
      p-id="3003"
    ></path>
    <path
      d="M928 704.2a96 96 0 0 0-66.218-91.23C728.382 808.896 518.95 920 377.292 976H880a48 48 0 0 0 48-48z"
      fill="#EA4A3B"
      p-id="3004"
    ></path>
    <path
      d="M291.06 437.88l-90.98 36.42-43.18-57.32L80 314.84 121.26 160l120.14 70.04 20.56 11.98z"
      fill="#E0E0DE"
      p-id="3005"
    ></path>
    <path
      d="M291.06 437.88l-90.98 36.42-43.18-57.32c30.82-49.14 60.64-110.66 84.5-186.94l20.56 11.98z"
      fill="#D6D6D4"
      p-id="3006"
    ></path>
    <path
      d="M321.388 425.74l-151.632 60.69 24.864 59.218 151.63-60.69z"
      fill="#FFB531"
      p-id="3007"
    ></path>
    <path
      d="M523.47 900.686c-14.554-48.382-30.568-96.352-48.372-143.688-35.314-93.894-77.78-185.282-128.848-272.04L194.62 545.648c41.758 155.446 92.222 291.018 174.236 430.352H544c-3.072-22-13.2-50.978-20.53-75.314z"
      fill="#3D4D63"
      p-id="3008"
    ></path>
    <path
      d="M321.386 425.74l-56.15 22.474 25.302 59.042 55.712-22.298z"
      fill="#FFA912"
      p-id="3009"
    ></path>
    <path
      d="M523.47 900.686c-14.554-48.382-30.568-96.352-48.372-143.688-35.314-93.894-77.78-185.282-128.848-272.04l-45.85 18.352c104.048 172.216 165.81 366.322 193.69 472.69H544c-3.072-22-13.2-50.978-20.53-75.314z"
      fill="#374559"
      p-id="3010"
    ></path>
    <path
      d="M736 784l-480 48v96a48 48 0 0 0 48 48h88.548a47.986 47.986 0 0 0 14.554-2.26L736 869.09 848 848l80 32v-128l-96-16z"
      fill="#FEB784"
      p-id="3011"
    ></path>
    <path
      d="M448 784l480 48v96a48 48 0 0 1-48 48h-88.548a47.986 47.986 0 0 1-14.554-2.26L448 869.09 336 848l-80 32v-128l96-16z"
      fill="#FEC9A3"
      p-id="3012"
    ></path>
    <path
      d="M596.346 576A120.53 120.53 0 0 0 672 549.224V480h-160v69.224A120.528 120.528 0 0 0 587.654 576z"
      fill="#FEB784"
      p-id="3013"
    ></path>
    <path
      d="M768.16 279.18L720 448H464c-29.34-48.3-36.16-63.12-46.24-100.72-14.7-54.84-34.5-110.72-31.56-168.24 2.3-44.88 25.06-94.94 77.8-94.94l58.7-22.98a188 188 0 0 1 26.6-8.22 190.26 190.26 0 0 1 159.88 35.26c3.36 2.64 6.62 5.36 9.76 8.2 50.52 45.46 67.88 117.46 49.22 182.82z"
      fill="#7A432A"
      p-id="3014"
    ></path>
    <path
      d="M768.16 279.18L720 448h-67.56a145.43 145.43 0 0 0 3.56-32V192a144.06 144.06 0 0 0-106.7-139.1 190.26 190.26 0 0 1 159.88 35.26c3.36 2.64 6.62 5.36 9.76 8.2 50.52 45.46 67.88 117.46 49.22 182.82z"
      fill="#743B20"
      p-id="3015"
    ></path>
    <path
      d="M752 272h-16v96h16a48 48 0 0 0 0-96zM432.8 272h-0.8a48 48 0 0 0 0 96h16v-96z"
      fill="#FEB784"
      p-id="3016"
    ></path>
    <path
      d="M736 208v174.68a173.57 173.57 0 0 1-62.46 133.38 120.576 120.576 0 0 1-77.2 27.94h-8.68c-3.02 0-6.02-0.12-9-0.34a120.514 120.514 0 0 1-68.2-27.6A173.6 173.6 0 0 1 448 382.68V272a190.6 190.6 0 0 0 32-105.68V128h33.36c61.12 0 94.64 80 142.64 80z"
      fill="#FEC9A3"
      p-id="3017"
    ></path>
    <path
      d="M736 208v174.68a173.57 173.57 0 0 1-62.46 133.38 120.576 120.576 0 0 1-77.2 27.94h-8.68c-3.02 0-6.02-0.12-9-0.34A143.986 143.986 0 0 0 656 416V208z"
      fill="#FEC093"
      p-id="3018"
    ></path>
    <path
      d="M624 272m19.2 0l73.6 0q19.2 0 19.2 19.2l0 25.6q0 19.2-19.2 19.2l-73.6 0q-19.2 0-19.2-19.2l0-25.6q0-19.2 19.2-19.2Z"
      fill="#E0E0DE"
      p-id="3019"
    ></path>
    <path
      d="M448 272m19.2 0l73.6 0q19.2 0 19.2 19.2l0 25.6q0 19.2-19.2 19.2l-73.6 0q-19.2 0-19.2-19.2l0-25.6q0-19.2 19.2-19.2Z"
      fill="#E0E0DE"
      p-id="3020"
    ></path>
    <path
      d="M845.834 593.084l-143.928-18.084a15.866 15.866 0 0 1-13.906-15.8v-34.482a189 189 0 0 0 63.54-129.012l3.4-11.78a63.974 63.974 0 0 0 32.556-117.15 201.778 201.778 0 0 0-3.038-92.672A185.674 185.674 0 0 0 729.55 84.4c-3.946-3.532-7.428-6.442-10.644-8.896a206.69 206.69 0 0 0-202.03-29.278L460.846 68.2c-58.836 1.874-87.894 56.2-90.582 109.97-1.948 36.2 4.714 71.114 12.214 101.33a63.938 63.938 0 0 0 28.62 100.966c7.066 19.922 15.902 36.59 30.2 60.974A189.048 189.048 0 0 0 496 524.716V559.2a15.74 15.74 0 0 1-12.354 15.524c-0.6 0.08-1.114 0.178-1.532 0.268h-0.098c-4.15 0.52-44.12 5.554-64.7 8.162-18.102-36.66-37.134-72.028-56.684-105.282l-24.494-58.336a16 16 0 0 0-20.696-8.66l-11.532 4.614-26.126-175.832a16 16 0 0 0-7.77-11.47L129.308 146.176A16 16 0 0 0 105.8 155.882l-41.26 154.848a16 16 0 0 0 2.678 13.744l107.5 142.736-10.906 4.366a16 16 0 0 0-8.8 21.048l24.314 57.908C197.954 620.2 217.82 683 240 742.4V928a64.072 64.072 0 0 0 64 64h240a16 16 0 0 0 15.846-18.2 238 238 0 0 0-6.57-29.818l38.674-12.292 180.094 57.302a63.904 63.904 0 0 0 19.4 3.014H880a64.072 64.072 0 0 0 64-64V704.16a112.012 112.012 0 0 0-98.166-111.076zM912 814.32l-167.386-16.738 89.888-44.944L912 765.554z m0-110.16v28.952l-77.37-12.894a16 16 0 0 0-9.786 1.472l-93.366 46.682L592 782.32l-93.968-9.4c-2.66-7.294-5.364-14.518-8-21.562a1819.232 1819.232 0 0 0-58.042-137.8c15.248-1.928 34.542-4.36 45.662-5.758a138.908 138.908 0 0 0 233.8 0.64l130.442 16.4A79.986 79.986 0 0 1 912 704.16zM528 559.2v-12.966A136.754 136.754 0 0 0 587.654 560h8.692A136.754 136.754 0 0 0 656 546.234v12.966a47.97 47.97 0 0 0 22.318 40.522A106.868 106.868 0 0 1 509.2 597.2a47.934 47.934 0 0 0 18.8-38zM613.736 272h-43.472a35.178 35.178 0 0 0-29.464-16h-65.302A205.764 205.764 0 0 0 496 166.316V144h17.352c26.2 0 47.2 19.156 69.436 39.438C604.646 203.38 627.248 224 656 224h64v32.162a35.3 35.3 0 0 0-3.2-0.162h-73.6a35.178 35.178 0 0 0-29.464 16zM464 291.2a3.2 3.2 0 0 1 3.2-3.2h73.6a3.2 3.2 0 0 1 3.2 3.2v25.6a3.2 3.2 0 0 1-3.2 3.2h-73.6a3.2 3.2 0 0 1-3.2-3.2z m176 0a3.2 3.2 0 0 1 3.2-3.2h73.6a3.2 3.2 0 0 1 3.2 3.2v25.6a3.2 3.2 0 0 1-3.2 3.2h-73.6a3.2 3.2 0 0 1-3.2-3.2z m112 60.8v-64a32 32 0 0 1 0 64zM402.22 179.838c1.838-36.754 19.12-79.678 61.78-79.678a15.97 15.97 0 0 0 5.844-1.106l58.706-23.034a174.564 174.564 0 0 1 170.698 24.73l0.176 0.138c2.564 1.952 5.436 4.358 8.774 7.344 39.96 35.836 58.256 92.6 48.696 147.974-1.616-0.124-3.244-0.2-4.892-0.2v-48a16 16 0 0 0-16-16H656c-16.348 0-33.494-15.642-51.644-32.2C579.8 137.4 551.964 112 513.352 112H480a16 16 0 0 0-16 16v38.316A173.862 173.862 0 0 1 439.164 256H432a63.71 63.71 0 0 0-21.344 3.672c-5.616-24.832-9.92-52.252-8.436-79.834zM432 288v64a32 32 0 0 1 0-64z m32 94.688v-30.85c1.056 0.096 76.8 0.162 76.8 0.162a35.242 35.242 0 0 0 35.2-35.2V304h32v12.8a35.242 35.242 0 0 0 35.2 35.2s75.744-0.066 76.8-0.162c0 0-0.08 36.664-0.238 39.552 0 0.064 0 0.13-0.012 0.2a157.134 157.134 0 0 1-56.458 112.178A104.77 104.77 0 0 1 596.346 528h-8.692a104.77 104.77 0 0 1-66.946-24.238A157.178 157.178 0 0 1 464 382.688z m-3.942 379.89l2.548 6.8-10.084-1-93.366-46.682a16.016 16.016 0 0 0-9.786-1.472l-10.024 1.67a1577.71 1577.71 0 0 1-25.708-67.562l-30.156 10.708a1626.334 1626.334 0 0 0 23.52 62.244l-36.238 6.04c-20.754-55.354-39.458-113.744-57.03-178.086l125.634-50.284c18.732 32.492 36.946 66.918 54.242 102.524a1786.332 1786.332 0 0 1 66.448 155.1zM325.2 476.142l-121.938 48.75L190.8 495.24l121.918-48.8z m-227.736-164.7l27.18-102.03 45.618 108.642a32.094 32.094 0 0 0-4.35 7.37 31.454 31.454 0 0 0 0.016 24.492 32.626 32.626 0 0 0 42.074 17.4 31.948 31.948 0 0 0 17.772-17.434 31.422 31.422 0 0 0-0.016-24.486 32.4 32.4 0 0 0-25.874-19.444L154.522 197.914l92.738 54.06 26.116 175.748-67.876 27.168zM502.94 960l19.828-6.316c0.574 2.11 1.134 4.22 1.66 6.316z m25.8-41.8l-126.444 40.28a33.6 33.6 0 0 1-9.816 1.52H304a32.038 32.038 0 0 1-32-32v-37.168l65.618-26.246 106.462 20.048 95.078 30.252zM912 928a32.038 32.038 0 0 1-32 32h-88.548a31.928 31.928 0 0 1-9.702-1.506l-328.898-104.65a15.772 15.772 0 0 0-1.892-0.476l-112-21.092a16 16 0 0 0-8.902 0.868L272 856.368v-90.814l77.498-12.916 91.346 45.672a15.978 15.978 0 0 0 5.564 1.61L912 846.48z"
      p-id="3021"
    ></path>
    <path
      d="M575.49 447.642c4.136-0.2 28.884-0.2 33.022 0 4.748 0.24 9.622 0.358 14.458 0.358a232.338 232.338 0 0 0 33-2.104l2.444-0.372-4.8-31.636-2.44 0.37a227.47 227.47 0 0 1-41.024 1.426c-4.674-0.238-31.59-0.238-36.262 0a227.8 227.8 0 0 1-41.024-1.426l-2.442-0.37-4.8 31.636 2.446 0.372a258.256 258.256 0 0 0 47.422 1.746zM262.928 603.454a1737.646 1737.646 0 0 0 10.024 30.894l30.344-10.158a1706.332 1706.332 0 0 1-9.838-30.326z"
      p-id="3022"
    ></path>
  </svg>
);
